import { Box, Grid, TextField, InputLabel, FormControlLabel, Checkbox, Select, MenuItem, Button, List, ListItem, ListItemText, IconButton, FormControl, FormHelperText } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import { useTheme } from '@mui/material/styles'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import SaveIcon from '@mui/icons-material/Save'
import { useForm, Controller } from 'react-hook-form'
import { useTaskContext } from '../../../shared/context/taskContext'
import { useState, useEffect } from 'react'
import { useUtiles } from '../../../shared/context/utilesContext'
export default function AddSubTaskFormComponent() {
    const { control, handleSubmit, formState: { errors }, watch } = useForm()
    const theme = useTheme()
    const { subtask, setSubtask, subtaskValue, setSubtaskValue, subtaskList, setSubtaskList, resetSubtask, indexSubtask, setIndexSubtask } = useTaskContext()

    const { toogleOpenSilder, generateRandomCode } = useUtiles()





    const handleInputChange = (key, value) => {
        setSubtask({
            ...subtask,
            [key]: value
        })
    }

    const handleAddSubtask = (subtask, indexSubtask) => {
        // Remove options if type is not list
        const subtaskToSave = subtask.type_field !== 'list' 
            ? { ...subtask, options: undefined }
            : subtask;
        
        if (indexSubtask !== undefined && indexSubtask !== null) {
            // Actualizar una subtarea existente
            const newSubtaskList = [...subtaskList]
            newSubtaskList[indexSubtask] = {
                ...subtaskList[indexSubtask],
                ...subtaskToSave
             }
            setSubtaskList(newSubtaskList)
        } else {
            //generar un codigo para la subtarea
            const code = generateRandomCode()
            const order = subtaskList.length + 1
            // Agregar una nueva subtarea
            setSubtaskList([...subtaskList, {...subtaskToSave, order, code}])
        }

        // Limpiar el formulario después de guardar
        resetSubtask()
        toogleOpenSilder(null, 0, null)
        setIndexSubtask(null)
    }

   
    //Agregar opciones a la subtarea
    const [indexEditOption, setIndexEditOption] = useState(null)
    const handleAddOptionSubtask = (value, indexSubtask) => {
        //manejar las opciones de la subtarea
        // si se edita (si hay indexEditOption) se actualiza el valor de la opción
        // si no se edita se agrega una nueva opción
        const options = subtask.options || []
        if (indexEditOption !== null) {
            options[indexEditOption] = { value }
        } else {
            options.push({ value })
        }

        if (indexSubtask !== undefined) {
            // Si estamos editando una subtarea existente
            const newSubtaskList = [...subtaskList]
            newSubtaskList[indexSubtask] = {
                ...newSubtaskList[indexSubtask],
                options: [...options]
            }
            setSubtaskList(newSubtaskList)
        } else {
            // Si estamos creando una nueva subtarea
            setSubtask({
                ...subtask,
                options: [...options]
            })
        }
        
        // Reset the edit index after updating
        setIndexEditOption(null)
    }

   

    

    useEffect(() => {
        if (subtask.type_field) {
            setSubtaskValue({ value: ''})
        }
    }, [subtask.type_field])

    return (
        <Box sx={{
            padding: '20px',
        }}>
            <Grid container spacing={2}>
                <Grid item size={{ xs: 12 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'start', gap: '10px' }}>
                        <FormControlLabel
                            control={
                                <Checkbox 
                                    checked={subtask.is_mandatory || false}
                                    onChange={(e) => handleInputChange('is_mandatory', e.target.checked)}
                                />
                            }
                            label="Campo Obligatorio"
                        />
                       { /*<FormControlLabel
                            control={
                                <Checkbox 
                                    checked={subtask.require_attachment || false}
                                    onChange={(e) => handleInputChange('require_attachment', e.target.checked)}
                                />
                            }
                            label="Adjunto Obligatorio"
                        />*/}
                    </Box>
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel>Descripción</InputLabel>
                    <Controller
                        control={control}
                        name="description"
                        rules={{ required: 'La descripción es requerida' }}
                        render={({ field }) => (
                            <TextField
                                fullWidth
                                placeholder='Descripción breve de la sub tarea'
                                value={subtask.description || ''}
                                onChange={(e) => handleInputChange('description', e.target.value)}
                                error={!subtask.description}
                                helperText={!subtask.description ? 'La descripción es requerida' : ''}
                            />
                        )}
                    />
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <InputLabel>Tipo de campo</InputLabel>
                    <FormControl fullWidth>
                        <Controller
                            control={control}
                            name="type_field"
                            rules={{ required: 'El tipo de campo es requerido' }}
                            render={({ field }) => (
                                <Select
                                    fullWidth
                                    placeholder='Tipo de campo'
                                    value={subtask.type_field || ''}
                                    onChange={(e) => handleInputChange('type_field', e.target.value)}
                                    error={!subtask.type_field}
                                >
                                    <MenuItem disabled>Selecciona un tipo de campo</MenuItem>
                                    <MenuItem value="text">Texto</MenuItem>
                                    <MenuItem value="number">Número</MenuItem>
                                    <MenuItem value="date">Fecha</MenuItem>
                                    <MenuItem value="boolean">Si/No</MenuItem>
                                    <MenuItem value="list">Lista</MenuItem>
                                    <MenuItem value="datetime-local">Fecha y hora</MenuItem>
                                    {/*<MenuItem value="file">Archivo adjunto</MenuItem>*/}
                                </Select>
                            )}
                        />
                        <FormHelperText error>{!subtask.type_field ? 'El tipo de campo es requerido' : ''}</FormHelperText>
                    </FormControl>
                </Grid>
                {subtask.type_field === "list" && (
                    <Grid item size={{ xs: 12 }}>
                        <InputLabel>Opciones</InputLabel>
                        <Box sx={{ display: 'flex', justifyContent: 'start', alignItems: 'center', gap: '10px' }}>
                        <Controller
                            control={control}
                            name="value"
                            rules={{ required: 'El texto de la opción es requerido' }}
                            render={({ field }) => (
                                <TextField
                                    fullWidth
                                    placeholder='Texto de la opción'
                                    value={subtaskValue.value || ''}
                                    onChange={(e) => setSubtaskValue({...subtaskValue, value: e.target.value})}
                                    helperText={!subtaskValue.value ? 'El texto de la opción es requerido' : ''}
                                    sx={{
                                        height: '40px',
                                    }}
                                />
                            )}
                        />
                        <Button 
                            variant="contained" 
                            color="primary" 
                            startIcon={<AddIcon />}
                            disabled={!subtaskValue.value}
                            onClick={() => {
                                if (subtaskValue.value) {
                                    handleAddOptionSubtask(subtaskValue.value)
                                    setSubtaskValue({...subtaskValue, value: ''})
                                }
                            }}
                            sx={{
                                borderRadius: '50px',
                                padding: '8px 25px',
                                backgroundColor: theme.palette.primary.main,
                                color: theme.palette.primary.contrastText,
                                height: '40px',
                            }}
                        >
                            Agregar
                        </Button>
                        </Box>
                    </Grid>
                )}
                {subtask.type_field === "list" && (
                    <Grid item size={{ xs: 12 }}>
                        <List>
                        {subtask.options?.map((option, index) => (
                            <ListItem 
                                key={index}
                                secondaryAction={
                                    <Box sx={{ display: 'flex', gap: '10px' }}>
                                        <IconButton onClick={() => {
                                            setIndexEditOption(index)
                                            setSubtaskValue({...subtaskValue, value: option.value})
                                        }}>
                                            <EditIcon />
                                        </IconButton>
                                        <IconButton onClick={() => {
                                            const newOptions = subtask.options.filter((_, i) => i !== index)
                                            setSubtask({...subtask, options: newOptions})
                                        }}>
                                            <DeleteIcon />
                                        </IconButton>
                                    </Box>
                                }
                            >
                                <ListItemText>{option.value}</ListItemText>
                            </ListItem>
                        ))}
                        </List>
                    </Grid>
                )}

                <Grid item size={{ xs: 12 }}>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!subtask.description || !subtask.type_field}
                        onClick={() => handleAddSubtask(subtask, indexSubtask)}
                        sx={{
                            borderRadius: '50px',
                            padding: '8px 25px',
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                        }}
                        startIcon={<SaveIcon />}
                    >
                        Guardar
                    </Button>
                </Grid>
            </Grid>
        </Box>
    )
}